// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { Component, OnInit, Input, Output, SimpleChanges, OnChanges, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-data-table-filter',
    templateUrl: './data-table-filter.component.html',
})
export class DataTableFilterComponent {

    @Input() filter = '';
    @Input() placeholder = 'Search';
    @Output() filterChange = new EventEmitter();

    constructor() { }

    filterList(text: string) {
        this.filterChange.emit(text);
    }
    clearFilter() {
        this.filter = '';
        this.filterChange.emit('');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-table/data-table-filter/data-table-filter.component.ts